// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderApprovalsDataViewContext } from "@insite/client-framework/Store/Data/OrderApprovals/OrderApprovalsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import myAccountFilterSectionStyles from "@werner/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { pluralize } from "@werner/XDL/Utilities";
import React from "react";
import { useContext } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface OrderApprovalListCountStyles {
    wrapper?: InjectableCss;
    orderCountText?: TypographyPresentationProps;
}

const orderApprovalListCountStyles: OrderApprovalListCountStyles = {
    wrapper: {
        css: css`
            display: flex;
            margin-bottom: 4px;
        `,
    },
    orderCountText: {
        ...myAccountFilterSectionStyles.resultCountTextStyles,
    },
};
const styles = orderApprovalListCountStyles;

const OrderApprovalListCount = (props: Props) => {
    const orderApprovalsDataView = useContext(OrderApprovalsDataViewContext);
    const orderApprovalsCount =
        orderApprovalsDataView.value && orderApprovalsDataView.pagination
            ? orderApprovalsDataView.pagination.totalItemCount
            : 0;

    if (orderApprovalsCount === 0) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.orderCountText}>
                {`${orderApprovalsCount} ${translate(pluralize(orderApprovalsCount, "Order"))}`}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderApprovalListCount,
    definition: {
        group: "Order Approval List",
        displayName: "Order Approval List Results Count",
        allowedContexts: ["OrderApprovalListPage"],
    },
};

export default widgetModule;
